/* istanbul ignore file */
import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export type ModalSize = 'sm' | 'md' | 'md plus' | 'lg';

@Component({
  selector: 'pgh-modal-window',
  templateUrl: './modal-window.component.html',
  styleUrls: ['./modal-window.component.scss']
})
export class ModalWindowComponent {
  @Input() size: ModalSize = 'md';
  @Input() closeButton = true;

  constructor(public dialogRef: MatDialogRef<ModalWindowComponent>) {
    // this property was not allowing to close the modal with esc key
    // dialogRef.disableClose = true;
  }
}
